export default "__VITE_ASSET__D9kBZv2j__"